<div [formGroup]="learningCenterForm" id="first-section-input-container" class="card p-4" style="height: 100%">
  <h3 style="font-weight: 700; color:#060E9F">รายละเอียดส่วนที่ 1<lifedi-require></lifedi-require></h3>
  <div class="row">
    <div class="col-md-12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzFor="learning-center-name" nzTooltipTitle="แนะนำให้ไม่ซ้ำกัน">ชื่อศูนย์เรียนรู้<lifedi-require></lifedi-require></nz-form-label>
        <nz-form-control nzValidatingTip="Validating..." [nzErrorTip]="centerNameErrorTpl" nzSuccessTip="ใช้งานได้" [nzSpan]="24">
          <input formControlName="CENTER_NAME" nz-input type="text" class="form-control" id="learning-center-name-input" placeholder="ระบุชื่อศูนย์เรียนรู้ย่อยของคุณ">
          <ng-template #centerNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">โปรดระบุ</ng-container>
            <ng-container *ngIf="control.hasError('invalidName')">ชื่อศูนย์เรียนรู้ซ้ำกับในระบบ</ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzFor="learning-center-description">
          คำอธิบาย<lifedi-require></lifedi-require>
        </nz-form-label>
        <nz-form-control nzErrorTip="โปรดระบุ" [nzSpan]="24">
          <textarea formControlName="CENTER_DESCRIPTION" nz-input rows="8" class="form-control" id="learning-center-name-text-area" placeholder="ระบุคำอธิบาย"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</div>
